import { Tab } from '@app/shared/components/tabs/tab.interface';
import { ManagingCompanyAuthorityType } from '@app/shared/models/managing-company-authorities.interface';

export const managingCompanyAdministrationTabs: (Tab & { requiredAuthority: ManagingCompanyAuthorityType })[] = [
  {
    name: 'Users',
    path: '/managing-company-administration/{managingCompanyId}/managing-company-users',
    dataCy: 'managing-company-administration-tabs',
    isAuthorized: () => true,
    requiredAuthority: ManagingCompanyAuthorityType.MANAGING_COMPANY_ADMIN
  },
  {
    name: 'Authority Requests',
    path: '/managing-company-administration/{managingCompanyId}/managing-company-authority-requests',
    dataCy: 'managing-company-authority-requests-tabs',
    isAuthorized: () => true,
    requiredAuthority: ManagingCompanyAuthorityType.MANAGE_GLOBAL_AUTHORITY_REQUEST
  }
];
